import $ from "jquery";

export default class FormSection {
  $el = $("section.form");
  $spinner = this.$el.find(".spinner");

  constructor() {
    if (!this.$el.length) return;

    this.init();
  }

  init() {
    this.exampleFunction();
  }

  exampleFunction() {
    const prodApiUrl = "https://booking.rocksteadymusicschool.com/api";
    const stagingApiUrl = "https://staging.rocksteadymusicschool.com/api";
    const apiUrl = prodApiUrl;

    let schools = [];
    let schoolName = "";
    let schoolPostcode = "";
    let schoolURN = "";

    let searchTimeout = null;

    let schoolSelected = false;
    let searching = false;

    function findSchool(schoolName) {
      searching = true;
      schoolSelected = false;

      // Fetch Schools
      $.ajax({
        url: apiUrl + "/schools/find?q=" + schoolName,
        type: "GET",
        success: function (response) {
          schools = response;
          searching = false;
          displaySchools();
          $(".schoolNameSearch .spinner").addClass("opacity-0");
        },
        error: function (error) {
          searching = false;
          console.log("Error: ", error);
        },
      });
    }

    function displaySchools() {
      // Clear Schools
      $(".schoolNameSearchContainer").html("").hide();

      // Load Schools into the DOM
      schools.forEach((school) => {
        // Build div with data
        let schoolDiv = $(
          '<div class="p-2 hover:bg-gray-100 cursor-pointer">' +
            school.name +
            "</div>"
        );

        schoolDiv.on("click", function () {
          schoolSelected = true;
          schoolURN = school.id;
          schoolName = school.name;

          // Update Form
          $(".schoolNameSearch input").val(schoolName);
          $('input[name="school_urn"]').val(schoolURN).attr("readonly", true);
          $(".schoolNameSearchContainer").html("").hide();
        });

        // Append to container
        $(".schoolNameSearchContainer").append(schoolDiv).show();
      });
    }

    $(document).ready(function () {
      // Hide School Name Search Container
      $(".schoolNameSearchContainer").hide();

      // Set form date min attribute
      let today = new Date().toISOString().split("T")[0];
      $("#form_date").attr("min", today);

      // Set future date 6 months from now
      let monthsinFuture = 6;
      let futureDate = new Date();
      futureDate.setMonth(futureDate.getMonth() + monthsinFuture);
      futureDate = futureDate.toISOString().split("T")[0];
      $("#form_date").attr("max", futureDate);

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);

      console.log(urlParams);

      console.log(urlParams.get("utm_campaign"));
      console.log(urlParams.get("utm_medium"));
      console.log(urlParams.get("utm_source"));
      console.log(urlParams.get("utm_content"));

      // Form Submission
      $(".leadForm").submit(function (e) {
        e.preventDefault();
        console.log("Form Submitted");


        // Form Date
        var form_date = $("#form_date").val();
        if(form_date){
          var day = new Date(form_date).getUTCDay();
          console.log("Day selected is: "+day);
          if([6,0].includes(day)){
            // Alert is weekend
            alert('Office is closed on weekends');
            return;
          }
        }
        
        // Form Time
        var form_time = $("#form_time").val();
        
        // Get Preferred Call Back Time and format to “2024-07-22T11:00:00Z”
        let preferred_call_back_time = null;
        if (form_date && form_time) {
          preferred_call_back_time =
            form_date + "T" + form_time + ":00Z";
        }

        // Check if school is selected
        // if (!schoolSelected) {
        //   alert("Please select a school from the list");
        //   return;
        // }

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        var job_title_value = $('#job_title_select').find(":selected").val();

        // Build body json
        let body = {
          sales_lead: {
            first_name: $('input[name="first_name"]').val(),
            last_name: $('input[name="last_name"]').val(),
            email: $('input[name="email"]').val(),
            phone_number: $('input[name="phone"]').val(),
            // job_title: $('input[name="job_title"]').val(),
            job_title: job_title_value,
            organisation: $('input[name="organisation"]').val(),
            urn: $('input[name="school_urn"]').val(),
            sales_leadable_type: "MarketingFormSubmission",
            sales_leadable_attributes: {
              comments: $('textarea[name="comments"]').val(),
              utm_campaign: urlParams.get("utm_campaign"),
              utm_medium: urlParams.get("utm_medium"),
              utm_source: urlParams.get("utm_source"),
              utm_content: urlParams.get("utm_content"),

              utm_term: urlParams.get("utm_term"),
              utm_creative_format: urlParams.get("utm_creative_format"),
              utm_keyword: urlParams.get("utm_keyword"),
              utm_marketing_tactic: urlParams.get("utm_marketing_tactic"),
              utm_source_platform: urlParams.get("utm_source_platform"),
              placement: urlParams.get("placement"),
              site_source_name: urlParams.get("site_source_name"),

              data: {
                preferred_call_back_time: preferred_call_back_time,
                opted_in_for_marketing: false,
              },
            },
          },
        };

        console.log(body);

        // Grey out form during submission
        $(".leadForm").append(
          '<div class="absolute inset-0 bg-white bg-opacity-50 flex items-center justify-center"></div>'
        );

        // Submit
        $.ajax({
          url: apiUrl + "/sales_leads",
          type: "POST",
          data: body,
          success: function (response) {
            console.log("Form Submitted: ", response);
            $(".leadForm").html(
              '<div class="text-center text-white text-2xl">Thank you for registering your interest. We will be in touch soon.</div>'
            );
          },
          error: function (error) {
            console.log("Error: ", error);
            $(".leadForm").append(
              '<div class="absolute inset-0 bg-red-500 bg-opacity-50 flex items-center justify-center text-white">Error Submitting Form</div>'
            );
          },
        });

        // Log Form Data for Debugging
        // console.log('Form Data: ', body);
      });

      // School Name Search
      $(".schoolNameSearch input").on("keyup", function () {
        // Clear Timeout
        clearTimeout(searchTimeout);

        schoolName = $(this).val();

        // Set Timeout to search after 500ms of idle to give user time to type
        searchTimeout = setTimeout(function () {
          $(".schoolNameSearch .spinner").removeClass("opacity-0");

          if (schoolName.length > 2 && !searching) {
            findSchool(schoolName);
          } else {
            // clear schools
            $(".schoolNameSearchContainer").html("").hide();
          }
        }, 500);
      });

      // Off Focus, hide school search container
      $(".schoolNameSearch input").on("focusout", function () {
        setTimeout(() => {
          if (!schoolSelected) {
            $(".schoolNameSearchContainer").hide();
          }
        }, 200);
      });

      // On Focus, show school search container
      $(".schoolNameSearch input").on("focus", function () {
        if (schools.length > 0 && !searching && !schoolSelected) {
          $(".schoolNameSearchContainer").show();
        }
      });
    });
  }
}
